export default __webpack_public_path__ + "static/media/unisex.2d8cebce.jpg";